import React from 'react';
import {Row,Col} from 'react-bootstrap'
import Header from '../../Components/Modules/Includes/Header'
import MdEmail from 'react-icons/lib/md/email'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MdCameraAlt from 'react-icons/lib/md/camera-alt'

import { connect } from 'react-redux';
import * as actions from '../../Actions';
import env from '../../config/env.js'
const apiUrl=env.apiUrl;

class EditProfile extends React.Component{

	constructor(props) {
	    super(props);
		this.state = {
			file: '',
			imagePreviewUrl: '',
			value: 1,
			name: '',
			email: false,
			type: false,
			userName: '',
			userEmail: '',
			typeChanged:false,
			changeName: false,
			changeEmail: false
		};
		this.editProfileSubmit=this.editProfileSubmit.bind(this);
		this.handleChangeName=this.handleChangeName.bind(this);
		this.handleChangeEmail=this.handleChangeEmail.bind(this);
		
	}
	handleChangeName(e){
		this.setState({userName:e.target.value,changeName: true});
	}
	handleChangeEmail(e){
		this.setState({userEmail:e.target.value,changeEmail: true});
	}
	componentWillReceiveProps(newProps) {
		if(newProps.profile.profileDetail && newProps.profile.profileDetail!==''){
			this.props.fetchLoginUserDetail();
			this.props.unsetProfileeditFlag();
		}
	 }
 	handleChange = (event, index, value) => this.setState({value});
  	_handleImageChange(e) {
    	e.preventDefault();
    	let reader = new FileReader();
    	let file = e.target.files[0];
    	reader.onloadend = () => {
      		this.setState({
		        file: file,
		        imagePreviewUrl: reader.result
	      	});
	    }
	    reader.readAsDataURL(file)
	}
	editProfileSubmit(e){
		e.preventDefault();
		var image = document.EditProfile.profile_image.value;
		var name  = document.EditProfile.fullname.value;
        var type  = this.state.value;
        var email = document.EditProfile.email.value;
        
        var currentEmail = document.EditProfile.currentEmail.value;
        var regxName = /^[a-zA-Z ]{1,40}$/;
        var validation='true';
        if(name===''){
            this.setState({name:'Please enter your name.'});
            validation='false';
            return false;
        }else{
        	if(!regxName.test(name)){
                this.setState({name:'Please input a valid name.'});
                return false;
            }else{
                this.setState({name:''});
            }
        }
        if(type===''){
            this.setState({type:true});
            validation='false';
            return false;
        }
        if(email===''){
            this.setState({email:'Please enter your email.'});
            validation='false';
            return false;
        }else{
        	this.setState({name:''});
        }
        var form = document.getElementById("myForm");
  		var formData = new FormData(form);
  		formData.append('name',name);
  		formData.append('email',email);
  		formData.append('type',type);

        if(validation==='true'){
        	let userId = this.props.currentuser.currentUser ? this.props.currentuser.currentUser._id : '';
        	let compId = this.props.currentuser.companydetail ? this.props.currentuser.companydetail.company_id : '';
            this.props.editProfileSave(formData,image,name,type,email,currentEmail,userId,compId);
            
        }
	}
	setType(usertype){
		this.setState({value:usertype});
		this.setState({typeChanged:true});
	}
	render(){
		let profile_image = (localStorage.getItem('profile_pic') !== 'null' && localStorage.getItem('profile_pic')) ? localStorage.getItem('profile_pic') : '/images/user.png';
        let {imagePreviewUrl} = this.state;
        let $imagePreview = null;
        var path=apiUrl;

        if (imagePreviewUrl) {
          $imagePreview = (<img src={imagePreviewUrl} alt="user" />);
        } else {
        	if(this.props.currentuser.currentUser && this.props.currentuser.currentUser.image && this.props.currentuser.currentUser.image!==''){
          		$imagePreview = (<img src={this.props.currentuser.currentUser.image.location} alt="user" />);
        	}else{
          		$imagePreview = (<img src={profile_image} alt="user" />);
        	}
        }
        
        let userName =  this.props.currentuser.currentUser ? this.props.currentuser.currentUser.name : '';
    	let userEmail = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.email : '';
    	let usertype = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.type : null;
    	if(usertype && !this.state.typeChanged){
    	this.setType(usertype);
    	}
		return(<div>
					<Header />
					<div className="dashboard-page">
						<div className="right-content-dashboard active-dashboard">
							<div className="change-password-content">
								<Row>
									<form id="myForm" name="EditProfile" onSubmit={this.editProfileSubmit} encType="multipart/form-data">
										<Col md={4}>
											<div className="profile-pic-section">
												<figure>
													{$imagePreview}
													<div className="upload-img-sec">
														<input type="file" id="profile-image" name="profile_image" className="file-uploads" 
	                                                            onChange={(e)=>this._handleImageChange(e)} accept="image/*"/>
	                                                     <label htmlFor="profile-image">
	                                                     	<MdCameraAlt  />  
	                                                     </label>	     
	                                                </div>            
												</figure>
												<h3>{userName}</h3>
												<p><MdEmail /> {userEmail}</p>
											</div>
										</Col>
										<Col md={8}>
											<div className="chenge-password-form">
												<div className="heading-sec">
													<h3>Edit Profile</h3>
												</div>
												 
				                                     <Row>
				                                        <Col md={12}>
				                                            <TextField
				                                                fullWidth={ true }
				                                                floatingLabelText="Full Name"
				                                                type="text"
				                                                name="fullname"
				                                                value={userName && !this.state.changeName?userName : this.state.userName}
				                                                onChange={this.handleChangeName}
				                                                errorText={this.state.name}
				                                            />
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12}>
		                                                    <SelectField
		                                                     fullWidth={ true }
													          floatingLabelText="Account Type"
													          value={this.state.value}
													          onChange={this.handleChange}
													          required={this.state.type}
													          name='membertype'
													          disabled={true}
													        >
													          <MenuItem value={1} primaryText="Admin" />
													          <MenuItem value={2} primaryText="Team Member" />
													          
													        </SelectField>
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12} className="margb20px" >
				                                            <TextField
				                                                fullWidth={ true }
				                                                floatingLabelText="Primary Email"
				                                                type="email"
				                                                name="email"
				                                                onChange={this.handleChangeEmail}
				                                                value={userEmail && !this.state.changeEmail?userEmail : this.state.userEmail}
				                                                required={this.state.email}
				                                                disabled={true}
				                                            />
				                                        </Col>
				                                    </Row>
				                                    <Row>
				                                        <Col md={12}>
				                                        	<input type='hidden' name="currentEmail" value={userEmail}/>
				                                          <div className="submit-buttton">
				                                           <RaisedButton label="Update" type="submit" labelColor="#fff" fullWidth={false} />
				                                          </div>
				                                        </Col>
				                                    </Row>
											</div>
										</Col>
									</form>
								</Row>
							</div>
						</div>
					</div>
			   </div>
			)
	}
}

const mapStateToProps= (state,props)=> {
    return {
      signUp : state.signup,
      currentuser: state.login,
      profile: state.profile
    };
}
export default connect(mapStateToProps,actions)(EditProfile);


// WEBPACK FOOTER //
// ./src/Components/Pages/EditProfile.js